"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analytics = void 0;
var utils_1 = require("./utils");
var uuid_1 = require("uuid");
var Version = 0.2;
var BI_ENDPOINT = "https://bi.orbs.network/putes/twap-ui-".concat(Version);
var sendBI = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                (0, utils_1.logger)(data);
                return [4 /*yield*/, fetch(BI_ENDPOINT, {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(data),
                    }).then()];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                (0, utils_1.logger)("Analytics error: ".concat(error_1));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
var Analytics = /** @class */ (function () {
    function Analytics() {
        this.timeout = undefined;
        this.data = {
            _id: (0, uuid_1.v4)(),
        };
    }
    Analytics.prototype.updateAndSend = function (values) {
        var _this = this;
        if (values === void 0) { values = {}; }
        this.data = __assign(__assign({}, this.data), values);
        if (process.env.NODE_ENV === "development") {
            (0, utils_1.logger)(this.data);
            return;
        }
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
            sendBI(_this.data);
        }, 1000);
    };
    Analytics.prototype.reset = function () {
        var _this = this;
        setTimeout(function () {
            _this.data = {
                _id: (0, uuid_1.v4)(),
                pageLoaded: true,
                moduleImported: true,
            };
        }, 1000);
    };
    Analytics.prototype.onLibInit = function (config, provider, account) {
        var _a;
        if (!config || !provider || !account)
            return;
        var walletConnectName;
        try {
            if (provider.isRabby) {
                walletConnectName = "Rabby Wallet";
            }
            else if (provider.isWalletConnect) {
                walletConnectName = "WalletConnect";
            }
            else if (provider.isCoinbaseWallet) {
                return "Coinbase Wallet";
            }
            else if (provider.isOkxWallet) {
                return "OKX Wallet";
            }
            else if (provider.isTrustWallet) {
                return "Trust Wallet";
            }
            else if (provider.isMetaMask) {
                return "MetaMask";
            }
            else {
                walletConnectName = (_a = provider === null || provider === void 0 ? void 0 : provider.session) === null || _a === void 0 ? void 0 : _a.peer.metadata.name;
            }
        }
        catch (error) { }
        this.updateAndSend({
            bidDelaySeconds: config === null || config === void 0 ? void 0 : config.bidDelaySeconds,
            chainId: config === null || config === void 0 ? void 0 : config.chainId,
            chainName: config === null || config === void 0 ? void 0 : config.chainName,
            exchangeAddress: config === null || config === void 0 ? void 0 : config.exchangeAddress,
            exchangeType: config === null || config === void 0 ? void 0 : config.exchangeType,
            lensAddress: config === null || config === void 0 ? void 0 : config.lensAddress,
            name: config === null || config === void 0 ? void 0 : config.name,
            partner: config === null || config === void 0 ? void 0 : config.partner,
            twapAddress: config === null || config === void 0 ? void 0 : config.twapAddress,
            twapVersion: config === null || config === void 0 ? void 0 : config.twapVersion,
            walletAddress: account,
            pageLoaded: true,
            walletConnectName: walletConnectName,
        });
    };
    Analytics.prototype.onCancelOrder = function (cancelOrderId) {
        this.updateAndSend({ cancelOrderId: cancelOrderId });
    };
    Analytics.prototype.onCancelOrderSuccess = function () {
        this.updateAndSend({ cancelOrderSuccess: true });
    };
    Analytics.prototype.onSubmitOrder = function (swapData) {
        var _a, _b, _c, _d;
        this.updateAndSend({
            fromTokenAddress: (_a = swapData.srcToken) === null || _a === void 0 ? void 0 : _a.address,
            toTokenAddress: (_b = swapData.dstToken) === null || _b === void 0 ? void 0 : _b.address,
            fromTokenSymbol: (_c = swapData.srcToken) === null || _c === void 0 ? void 0 : _c.symbol,
            toTokenSymbol: (_d = swapData.dstToken) === null || _d === void 0 ? void 0 : _d.symbol,
            fromTokenAmount: swapData.srcAmount.amount,
            fromTokenAmountUi: swapData.srcAmount.amountUi,
            toTokenAmount: swapData.outAmount.amount,
            toTokenAmountUi: swapData.outAmount.amountUi,
            chunksAmount: swapData.chunks,
            minDstAmountOut: swapData.dstMinAmount.amount,
            minDstAmountOutUi: swapData.dstMinAmount.amountUi,
            fillDelay: swapData.fillDelay.millis,
            fillDelayUi: swapData.fillDelay.text,
            deadline: swapData.deadline.millis,
            deadlineUi: swapData.deadline.text,
            srcChunkAmount: swapData.srcChunkAmount.amount,
            srcChunkAmountUi: swapData.srcChunkAmount.amountUi,
            action: "create",
        });
    };
    Analytics.prototype.updateAction = function (action) {
        this.updateAndSend({
            action: action,
        });
    };
    Analytics.prototype.onTxError = function (error, failedAction) {
        var _a;
        if ((0, utils_1.isTxRejected)(error)) {
            this.updateAndSend({ actionError: "rejected" });
        }
        else {
            var actionError = ((_a = error === null || error === void 0 ? void 0 : error.message) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || (error === null || error === void 0 ? void 0 : error.toLowerCase());
            this.updateAndSend({ actionError: actionError, failedAction: failedAction });
            exports.analytics.reset();
        }
    };
    Analytics.prototype.onWrapSuccess = function (wrapTxHash) {
        this.updateAndSend({
            wrapTxHash: wrapTxHash,
        });
    };
    Analytics.prototype.onUnwrapSuccess = function (unwrapTxHash) {
        this.updateAndSend({
            unwrapTxHash: unwrapTxHash,
        });
    };
    Analytics.prototype.onApproveSuccess = function (approvalTxHash) {
        this.updateAndSend({
            approvalTxHash: approvalTxHash,
        });
    };
    Analytics.prototype.onCreateOrderSuccess = function (newOrderId, createOrderTxHash) {
        this.updateAndSend({
            newOrderId: newOrderId,
            createOrderTxHash: createOrderTxHash,
        });
        this.reset();
    };
    Analytics.prototype.onModuleImported = function () {
        this.updateAndSend({
            moduleImported: true,
        });
    };
    Analytics.prototype.onUiCreashed = function (error) {
        this.updateAndSend({
            uiCrashedErrorMessage: error.message,
            uiCrashedErrorStack: error.stack,
        });
    };
    return Analytics;
}());
exports.analytics = new Analytics();
